export const config = {
  apiUrl: 'https://www.nomura-leathercraft.com/api',
  contentsUrl: 'https://nomura-leathercraft.com/pdf'
};